import { useInputCounterContext } from '../../input-counter'
import type { InputCounterScopedProps } from '../../input-counter.types'
import { InputCounterLabelVariants } from './input-counter-label.styles'

type InputCounterLabelProps = React.ComponentProps<'label'> & {
  children: React.ReactNode
}

export const InputCounterLabel = (props: InputCounterLabelProps) => {
  const { children, __scopeInputCounter } =
    props as InputCounterScopedProps<InputCounterLabelProps>

  const { disabled, readOnly, size } = useInputCounterContext(
    'InputCounterControl',
    __scopeInputCounter
  )
  return (
    <label
      className={InputCounterLabelVariants({
        disabled,
        readOnly,
        size,
      })}
    >
      {children}
    </label>
  )
}
